// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDfNayGjYknk-XeC8L4GCNUwpTIcOCs2J4',
  authDomain: 'itstartsup.firebaseapp.com',
  databaseURL: 'https://itstartsup.firebaseio.com',
  projectId: 'itstartsup',
  storageBucket: 'itstartsup.appspot.com',
  messagingSenderId: '400626403190',
  appId: '1:400626403190:web:38459b050b8ec640695c57',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
